export enum SmartJeffProjectUpdateStatus {
    Draft = 'Draft',
    Published = 'Published',
}

